<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Title Page">
<div class="ipadfp"><span aria-label="page i" id="page_i" role="doc-pagebreak"><span aria-label="page ii" id="page_ii" role="doc-pagebreak"><span aria-label="page iii" id="page_iii" role="doc-pagebreak"><img alt="The Shimmering State, by Meredith Westgate, Atria" class="imagefp" src="e9781982156732/images/title.jpg"/></span></span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?18c4e0ee